/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export enum JobFinancialsDrawsFilterCode {
  isOnlyActiveDraws = 'isOnlyActiveDrawsFilter',
  isAllDraws = 'isAllDrawsFilter',
}
